import React from 'react';
import { useSkipToContent } from '../../utils/accessibility';

interface SkipToContentProps {
  /**
   * ID of the main content element to skip to
   */
  contentId: string;
  /**
   * Custom text for the skip link
   */
  text?: string;
  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * A component that provides a skip link for keyboard users to bypass navigation
 * and go directly to the main content. The link is visually hidden until focused.
 */
export const SkipToContent: React.FC<SkipToContentProps> = ({
  contentId,
  text = 'Skip to main content',
  className = '',
}) => {
  const { handleSkip } = useSkipToContent(contentId);

  return (
    <a
      href={`#${contentId}`}
      className={`skip-to-content ${className}`}
      onClick={(e) => {
        e.preventDefault();
        handleSkip();
      }}
    >
      {text}
    </a>
  );
};